import { render } from "./PagarSection.vue?vue&type=template&id=d1ede01e&ts=true"
import script from "./PagarSection.vue?vue&type=script&lang=ts"
export * from "./PagarSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__